import CurrencyValue from '@/features/finances/components/CurrencyValue';
import { useTranslation } from 'react-i18next';

const NewOrderSummaryEmpty = () => {
	const { t } = useTranslation();

	return (
		<div className='flex justify-between text-base font-medium'>
			<span>
				{t('main.orders.components.create.components.summary.total')}
			</span>
			<CurrencyValue value={0} asset='other' />
		</div>
	);
};

export default NewOrderSummaryEmpty;
